import BaseObject from '../../../../base/base_object';
import {FEATURE_CB_FUNC, SERIVCES_FUNC_LIST} from "../../native/native_const";
import {AF} from "./providers/appsflyer/app_flayer_const";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";



class SerialExtentions extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'SerialExtentions';
    _HybridService = null;


    init(params) {
        super.init();
    }


    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        this._HybridService.setCbFunction(SERIVCES_FUNC_LIST.SERIAL_SET_CB, FEATURE_CB_FUNC.HYBRID_SERIAL_EXTENTIONS);

        return this;
    }

    updateSerialData(data){
        Event.fire(SYSTEM_EVENTS.SERIAL_UPDATE, data);

        try {
            let dt = JSON.stringify(data);
            let dtEncode = encodeURIComponent(dt);
            this._replaceInfoKey(AF.SERLAI_DATA, dtEncode);
        }
        catch (err){
            console.log('updateSerialData failed with error: ' + err);
        }


    }

    _replaceInfoKey(key, val) {
        let data = {
            key: key,
            val: val
        };
        Event.fire(SYSTEM_EVENTS.HYBRID_UPDATE_INFO_KEY, data);
    }


    onHybridDirectCall(data){
        this._executeFunc(data);
    }

    _executeFunc(data){
        let fn = this.getFuncName(data);

        if('function' === typeof this[fn]) {
            this[fn](data);
        }
    }

    getFuncName(data){
        let fn = data[AF.CB_FN];

        return (undefined !== fn) ? fn : '';
    }
}

export default SerialExtentions;
